import { functionMetadata } from './constants/functions.constants';

// Regex generators
export const regexToMatchTransposedDateFn = /_____([A-Za-z0-9_]+)/g;

export const getDateFnAndArgName = (argName: string) => {
  const dateFnMatch = argName.match(regexToMatchTransposedDateFn);
  if (dateFnMatch) {
    const argNameWithoutDateFn = argName.replace(regexToMatchTransposedDateFn, '');
    return { argNameWithoutDateFn, dateFn: dateFnMatch[0] };
  }
  return { argNameWithoutDateFn: argName, dateFn: '' };
};

export const restoreTransformedDateFunctions = (str: string) => {
  const regexPattern = /([A-Za-z0-9_]+)\[([^\]]+)\]_____([A-Za-z_]+)/g;
  return str.replace(regexPattern, (match, variable, property, fn) => {
    const formattedFn = fn.toLowerCase();
    return `${formattedFn}(${variable}[${property}])`;
  });
};

export const generateRxToExcludeWordsAndFn = () => {
  const excludedWords = functionMetadata.map((item) => item.name);
  const excludedWordsRegex = excludedWords.map((word) => `(${word}\\b)`).join('|');
  return new RegExp(`\\b(?!${excludedWordsRegex})\\w+\\[\\w+\\](_____\\w+)?`, 'g');
};

export const generateRxToMatchFunctions = (functionNames: string[]) => {
  const functionNamesRegex = functionNames.map((name) => `(${name}\\b)`).join('|');
  return new RegExp(`\\b(${functionNamesRegex})\\b`, 'gm');
};
